import React from "react";
import NestlingUploadForm from '../components/Form/NestlingUploadForm';


const NestlingUploadPage = () => {

  const columns = [
    { id: 'mcbSerial', label: 'mcbSerial', minWidth: 200 , align: 'left'},
    { id: 'mcbChassisSerial', label: 'mcbChassisSerial', align: 'center'},
    { id: 'scSerialNumber', label: 'scSerialNumber', align: 'center'},
    { id: 'McbFWVersion', label: 'McbFWVersion', align: 'center'},
    { id: 'ScFWVersion', label: 'ScFWVersion', align: 'center'},
    { id: 'startPacketTime', label: 'startPacketTime', align: 'center'},
    { id: 'error', label: 'error', align: 'center'},
    { id: 'runningPacketTime', label: 'runningPacketTime', align: 'center'},
    { id: 'action', label: 'Download', align: 'center', action: true},
  ];

  return (<NestlingUploadForm
            title="Nestling Upload"
            columns={columns}
            queryURL="/data/v1/tread-erlich"
            downloadURL="/data/v1/tread-erlich-file"
            />);
};

export default NestlingUploadPage;
